import React from "react";
import { Link } from "react-router-dom";
import banner from "../../../assets/img/antex-token-banner.png";
import thumbnail from "../../../assets/img/token-icon.png";
import SocialIcons from "../../../components/SocialIcons";
import { Facebook, Meet, Slack, Verified, Youtube } from "../../../IconTheme";

import metamask from "../../../assets/img/wallet/metamask.png";
const social_icons = [
	{
		icon: <Facebook />,
		link: "#",
	},
	{
		icon: <Slack />,
		link: "#",
	},
	{
		icon: <Youtube />,
		link: "#",
	},
	{
		icon: <Meet />,
		link: "#",
	},
];

const AntexTokenCard = () => {
	return (
		<div className="antex-token-card">
			<img src={banner} className="antex-token-card-banner" alt="img" />
			<div className="antex-token-card-author">
				<img src={thumbnail} alt="img" />
				<div className="content">
					<h4 className="name">
						AntexPad Token{" "}
						<span>
							<Verified />
						</span>{" "}
					</h4>
					<span>1 ANT = 0.002 USDT</span>
				</div>
				<SocialIcons
					data={social_icons}
					className="size--small justify-content-end"
				/>
			</div>
			<div className="px-md-4">
				<p>
					AntexPad is the first legal Metaverse and decentralized legal
					solutions platform that offer A to Z of web 3.0 needed legal
					services to every user who wishes a safe journey in Blockchain
					and Metaverse. AntexPad vision is to increase access to justice
					in web 3.0 by building the first Metaverse with legal use cases
					for web 3.0 users , as people have lost hope and confidence in
					justice systems worldwide.
				</p>
				<Link to="#" className="img-icon-btn">
					<img src={metamask} alt="" />
					<span>Add ANT to MetaMask</span>
				</Link>
			</div>
		</div>
	);
};

export default AntexTokenCard;
